import { DarkModeSwitch } from 'react-toggle-dark-mode';
import React from 'react';
import { useEffect, useState } from 'react';

const DarkModeToggle = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme ? savedTheme === 'dark' : true;
  });

  const updateTheme = (isDark) => {
    const theme = isDark ? 'dark' : 'light';
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  };

  const toggleDarkMode = () => {
    setIsDarkMode((prevMode) => !prevMode);
  };

  useEffect(() => {
    updateTheme(isDarkMode);
  }, [isDarkMode]);

  return (
    <>
      <style>
        {`
          .switch-container {
            transform: translateY(25%) translateX(25%);
          }
        `}
      </style>
      <div className="switch-container">
        <DarkModeSwitch
          style={{ marginBottom: '2rem' }}
          checked={isDarkMode}
          onChange={toggleDarkMode}
          size={30}
        />
      </div>
    </>
  );
};

export default DarkModeToggle;
